export const regions = [
    "Île-de-France",
    "Provence-Alpes-Côte d'Azur",
    "Auvergne-Rhône-Alpes",
    "Occitanie",
    "Nouvelle-Aquitaine",
    "Hauts-de-France",
    "Grand Est",
    "Bourgogne-Franche-Comté",
    "Bretagne",
    "Normandie",
    "Centre-Val de Loire",
    "Pays de la Loire",
    "Corse",
  ];